
import { defineComponent } from 'vue';
import { TEST_MODE_BANNER_HEIGHT } from 'SharedDir/constants/attention-bar-options';

export default defineComponent({
  name: 'TheAttentionBar',
  data() {
    return {
      TEST_MODE_BANNER_HEIGHT,
    };
  },
});
